if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.realButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('[data-sticky-atc-submit]');
        this.label = this.querySelector('[data-sticky-atc-label]');
        this.priceTarget = this.querySelector(`#price-sticky-${this.sectionId}`);

        if (!this.realButton || !this.button) return;

        this.button.addEventListener('click', () => {
          if (this.realButton.hasAttribute('disabled')) return;
          this.realButton.click();
        });

        this.observer = new IntersectionObserver(this.handleIntersect.bind(this));
        this.observer.observe(this.realButton);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribeVariantChange?.();
        document.body.classList.remove('has-sticky-atc');
      }

      handleIntersect(entries) {
        const entry = entries[0];
        const scrolledPast = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        this.classList.toggle('is-visible', scrolledPast);
        document.body.classList.toggle('has-sticky-atc', scrolledPast);
      }

      handleVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;

        const sourcePrice = event.data.html.getElementById(`price-${this.sectionId}`);
        if (sourcePrice && this.priceTarget) this.priceTarget.innerHTML = sourcePrice.innerHTML;

        const isDisabled = this.realButton.hasAttribute('disabled');
        this.button.disabled = isDisabled;
        if (this.label) {
          this.label.textContent = isDisabled ? window.variantStrings.soldOut : window.variantStrings.addToCart;
        }
      }
    }
  );
}
